// extracted by mini-css-extract-plugin
module.exports = {"emptyState":"UploadedTablesSection_emptyState__vemKD","loadingContainer":"UploadedTablesSection_loadingContainer__IdkBa"};